<!-- <div *ngIf="showXButton" class="col-md-12" style="margin-top: -25px; margin-left: 20px; text-align: right">
    <a (click)="cancelButton()" style="cursor: pointer;">
        <br>
        <mat-icon class="nc-icon-glyph ui-1_simple-remove" style="margin: auto; transform: scale(1.5);"></mat-icon>
    </a> -->
<!-- <button type="button" class="btn btn-md btn-primary" style="margin: auto;">Export To Excel</button> -->
<!-- </div> -->

<div class="col-md-12 stickyTitle"
    style="top:-25px; margin-top: -45px; text-align: right; background-color: white; opacity: 1;">
    <!-- <a *ngIf="showXButton" (click)="cancelButton()" style="cursor: pointer;">
        <br>
        <mat-icon class="nc-icon-glyph ui-1_simple-remove"
            style="padding-top: 10px; margin: auto; transform: scale(1.5);"></mat-icon>
    </a> -->
    <!-- <button type="button" class="btn btn-md btn-primary" style="margin: auto;">Export To Excel</button> -->
    <div class="PageTitle">
        <h3 style="text-align: center;" class="reduce-margin"><b>{{ moduleTitle }}</b></h3>
    </div>
</div>

<!-- <h3 style="text-align:center" mat-dialog-title><b>{{ moduleTitle }} List Corps</b></h3>
<hr> -->

<div [hidden]="hideLoader" class="container white_bg" style="padding-top: 40px;">
    <div id="preloader-wrapper">
        <div id="preloader" class="preloader2"> </div>
    </div>
</div>

<div class="row special-reduce-margin" style="margin-bottom: 0px;" [hidden]="hidePage">

    <!-- <div class="row"> -->


    <div class="row">

        <div class="col-md-2 reduce-margin">
            <div class="row" style="width: auto; white-space: nowrap;">
                <h4 class="col-md-1" style="width: auto; white-space: nowrap;"><b>Rule Name:</b></h4>

                <div class="col-md-1" style="width: auto; white-space: nowrap;">
                    <h4 style="font-size:16px; white-space: nowrap">{{ ruleName }}</h4>
                </div>
            </div>

            <!-- Removed for auto-approve feature

            <div class="row" style="width: auto; white-space: nowrap;">
                <h4 class="col-md-1" style="width: auto; white-space: nowrap;"><b>Rule Status:</b></h4>

                <div class="col-md-1" style="width: auto;">
                    <h4 style="font-size:16px; white-space: nowrap">{{ ruleStatus }}</h4>
                </div>
            </div>     -->

            <div class="row" style="width: auto; white-space: nowrap;">
                <h4 class="col-md-1" style="width: auto; white-space: nowrap;"><b>Description:</b></h4>

                <div class="col-md-1" style="width: auto;">
                    <h4 style="font-size:16px; white-space: nowrap">{{ ruleDescription }}</h4>
                </div>
            </div>

        </div>

        <div class="col-md-10" [hidden]="viewOnlyMode">

            <div [hidden]="ruleStatus=='Retired'" class="col-md-offset-4">
                <div class="row">
                    <div class="col-md-1 reduce-margin" style="width: 50px;">
                        <h4><b>Client</b></h4>
                    </div>
                </div>

                <div class="col-md-1 reduce-margin" style="width:300px">
                    <reusable-typeahead-search #search0 (messageEventObject)="receiveMessageObj($event)"
                        (messageEvent)="searchReceiveMessage($event)" [events]="clientEventSubject.asObservable()">
                    </reusable-typeahead-search>
                </div>

                <div class="col-md-1 reduce-margin" style="width:125px;">
                    <reusable-corp-search #fromCorp (messageEvent)="fromReceiveMessage($event)"
                        [events]="fromEventSubject.asObservable()"></reusable-corp-search>
                </div>

                <div class="col-md-1 reduce-margin" style="width:125px;">
                    <reusable-corp-search #toCorp (messageEvent)="toReceiveMessage($event)"
                        [events]="toEventSubject.asObservable()" [fromElement]="false"></reusable-corp-search>
                </div>



                <div class="col-md-1" id="buttonRow">
                    <div style="margin-top: -7px;">
                        <button (click)="clientSearchButton()" type="button" class="btn btn-md btn-primary" [disabled]="viewOnlyMode"
                            style="margin: auto;">Search</button>
                    </div>
                </div>

            </div>

        </div>


    </div>
    <hr>
    <br>


    <!-- left side -->
    <div class="reduce-margin" style="border-right: 0px solid lightsteelblue; height: auto; min-width: 500px;">

        <div class="col-md-4 reduce-margin" style="margin-right: -50px;">


            <div class="row col">
                <div class="col-md-1" style="width: auto;">
                    <h4 style="display: inline-block; white-space: nowrap;"><b>Associated Corps</b></h4>
                </div>

                <!-- Row 2 -->
                <div class="col-md-1" style="white-space: nowrap; width: auto; position:absolute; padding-left: 150px;">
                    <h4><b>&nbsp;&nbsp;&nbsp;&nbsp;Filter Corp:</b></h4>
                </div>

                <div class="col-md-1" style="width: 150px; position:absolute; padding-left: 275px;">
                    <mat-form-field class="reduce-margin no-wrapping" style="width: 100px">
                        <input maxlength="5" type="text" matInput [formControl]="assocFilterControl">
                        <!-- <mat-error *ngIf="workUnitSizeControl.status === 'INVALID'">Value must be positive</mat-error> -->
                    </mat-form-field>
                </div>
            </div>

            <br>

            <div class="row col">
                <!-- <div class="col-md-1" style="width: 550px; margin-left: -50px; overflow: scroll;"> -->
                <!-- source corp table  -->
                <div class="col-md-11" style="max-width: auto;">
                    <reusable-table-app #table0 (messageEvent)="table0ReceiveMessage($event)"
                        [events]="tableEventSubject.asObservable()" [displayedColumns]="displayedColumns"
                        [columns]="columns" [pageSizeOptions]="pageSizeOptions" [checkboxHeader]="checkboxHeader">
                    </reusable-table-app>
                </div>
            </div>


        </div>

        <div class="col-md-1" style="width:auto;" [hidden]="viewOnlyMode">
            <!-- <br><br><br><br> -->
            <button *ngIf="data.ruleClassName !== 'SLA'" [disabled]="ruleStatus=='Retired' || viewOnlyMode" (click)="removeCorps()" type="button" class="btn btn-md btn-primary"
                style="margin: auto; width: 75px;">Remove</button>
        </div>

        <div class="col-md-1" style="width:auto" [hidden]="viewOnlyMode">
            <button [disabled]="ruleStatus=='Retired' || viewOnlyMode" (click)="assocCorps()" type="button" class="btn btn-md btn-primary"
                style="margin: auto; width: 75px;">Add</button>
        </div>

        <div class="col-md-5 reduce-margin" style="margin-left: auto; margin-right: 0px;" [hidden]="viewOnlyMode">
            <div class="row">
                <div class="col-md-1">
                    <h4
                        style="margin-left:-15px; padding-left:0px; padding-top:0px; display: inline-block; white-space: nowrap;">
                        <b>Available Corps</b>
                    </h4>

                </div>
                <!-- COL 2 -->
                <div class="col-md-1 col-md-offset-1" style="white-space: nowrap; width: auto; position:absolute; padding-left: 100px;">
                    <h4><b>&nbsp;&nbsp;&nbsp;&nbsp;Filter Corp:</b></h4>
                </div>

                <div class="col-md-1" style="width: 150px; position:absolute; padding-left: 285px;">
                    <mat-form-field class="reduce-margin no-wrapping" style="width: 100px">
                        <input maxlength="5" type="text" matInput [formControl]="rightSideAvailFilterControl">
                        <!-- <mat-error *ngIf="workUnitSizeControl.status === 'INVALID'">Value must be positive</mat-error> -->
                    </mat-form-field>
                </div>

                <div class="col-md-1" style="width:250px" [hidden]="true">
                    <div class="row">
                        <div class="col-md-1 reduce-margin" style="margin-top:-25px">
                            <h4 style="color: red" class="no-wrapping prehold-font-size"><b
                                    style="color:black">Facility</b>
                            </h4>
                        </div>
                    </div>
                    <div class="reduce-margin col-md-1">
                        <mat-form-field style="width: 200px" appearance="outline" class="standard-font-sizing">
                            <mat-select [formControl]="facilityControl">
                                <mat-option (click)="selectAll()" [value]="allSelectedValue">
                                    No Facility
                                </mat-option>

                                <ng-container *ngIf="!toggleAllSelected; else allSelected">
                                    <mat-option *ngFor="let facility of facilitiesToHold" [value]="facility"
                                        (click)="facilityIdLookup(facility.facilityNm, 'true')">
                                        {{ facility.facilityNm }}
                                    </mat-option>
                                </ng-container>
                                <ng-template #allSelected>

                                </ng-template>

                            </mat-select>
                        </mat-form-field>
                    </div>

                </div>
            </div>
            <div class="row" style="margin-bottom: 0px;">
                <!-- target table -->
                <!-- <div class="col-md-11" style="width: 530px; overflow: auto; max-height: 600px; display: inline-block; white-space: nowrap"> -->
                <br>
                <reusable-table-app #table1 (messageEvent)="table1ReceiveMessage($event)"
                    [events]="table1EventSubject.asObservable()" [displayedColumns]="displayedColumns1"
                    [columns]="columns1" [pageSizeOptions]="pageSizeOptions" [checkboxHeader]="checkboxHeader">
                </reusable-table-app>
                <!-- </div> -->
            </div>
        </div>

        <br><br><br><br>



        <!-- <div class="col-md-1" style="width: 1%"></div> -->


    </div>

</div>

<div style="background-color: white; overflow: hidden;" [hidden]="hidePage">
    <hr style="margin-top: 0px;">

    <div class="row" id="buttonRow">

        <div class="col-md-1 col-md-offset-2" [hidden]="viewOnlyMode">
            <button id="exportButton" aria-hidden="true" (click)="downloadCsv()" matTooltip="Export to CSV"
                class="btn btn-md btn-primary">Export</button>
        </div>

        <div [hidden]="ruleStatus=='Retired'" class="col-md-1 col-md-offset-2" [hidden]="viewOnlyMode">
            <button [disabled]="toggleSaveButton || viewOnlyMode" (click)="saveButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Save</button>
        </div>

        <div class="col-md-1 col-md-offset-2">
            <button (click)="cancelButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Cancel</button>
        </div>
    </div>
</div>

<!-- Announcement Ticket -->
<!-- <div *ngIf="saveOccured">
    <ng-container *ngIf="saveStatus; else ticketTemplate">
        <h3 style="text-align:center"><b style="color:#00A3D6">Save Complete!</b></h3>
    </ng-container>
    <ng-template #ticketTemplate>
        <h3 style="text-align:center"><b style="color:lightcoral">Save did not go through.</b></h3>
    </ng-template>
</div> -->